import AcceptInvitePage from './components/AcceptInvitePage';

export default AcceptInvitePage;
